import { create } from 'zustand';

export interface AppNotification {
  id: string;
  type: 'escalation' | 'message' | 'lead';
  title: string;
  body: string;
  conversationId?: string;
  timestamp: string;
  read: boolean;
}

interface NotificationState {
  notifications: AppNotification[];
  unreadCount: number;
  /** `timestamp` is optional here: add() stamps "now" when the event carried none. */
  add: (n: Omit<AppNotification, 'id' | 'read' | 'timestamp'> & { timestamp?: string }) => void;
  markAllRead: () => void;
  clear: () => void;
}

/**
 * In-memory feed backing the header notification bell. Populated live from
 * WebSocket events (see useNotificationFeed). Not persisted — it reflects
 * what's happened while the dashboard is open.
 */
export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,
  add: (n) =>
    set((s) => {
      const item: AppNotification = {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
        read: false,
        timestamp: n.timestamp || new Date().toISOString(),
        type: n.type,
        title: n.title,
        body: n.body,
        conversationId: n.conversationId,
      };
      return {
        notifications: [item, ...s.notifications].slice(0, 50),
        unreadCount: s.unreadCount + 1,
      };
    }),
  markAllRead: () =>
    set((s) => ({ notifications: s.notifications.map((x) => ({ ...x, read: true })), unreadCount: 0 })),
  clear: () => set({ notifications: [], unreadCount: 0 }),
}));
